<template>
  <div>
    <div v-if="!loading" class="home-pag">
      <sectionx class="eventx team-secx team-grid speakerx set-relative" id="speakerx" style="">
        <div class="container" style="margin:auto;page-break-after: always;max-width:100%;">
        <!-- <div class="container" style="margin:auto;page-break-after: always;max-width:100%;-ms-transform: rotate(90deg);transform: rotate(90deg);"> -->
          <div class="row">
            <div class="col-md-3" v-for="index in 4" :key="index" style="">
              <div class="row" style="padding:0% 3%">
                <div class="col-md-12" style="padding:0px;margin-top:10px; text-align:right">
                  <p align="right" style="font-family: kalpurush;color black;color:black;font-size:10px;margin-bottom:0px">
                    <span v-if="index==1">ব্যাংক কপি</span>
                    <span v-else-if="index==2">হিসাব বিভাগ</span>
                    <span v-else-if="index==3">হল/দপ্তর বিভাগ কপি</span>
                    <span v-else-if="index==4">ছাত্র/ছাত্রীর কপি</span>
                  </p>
                </div>
                <div class="col-md-2" style="padding:5px">
                  <img alt="" class="img-fluid" style="padding-left:20%" src="../../theme-assets/images/logo/abl_logo.png">
                </div>
                <div class="col-md-8" style="padding:0px">
                  <img alt="" class="img-fluid" style="height:20px" src="../../theme-assets/images/logo/abl_name.png">
                  <img alt="" class="img-fluid" style="margin-top:-15px" src="../../theme-assets/images/logo/abl_moto.png">
                  <p align="center" style="font-family: kalpurush; font-size:16px; font-weight:bold; color:black; padding:5px 0px 5px 0px">চট্টগ্রাম বিশ্ববিদ্যালয় শাখা</p>
                </div>
                <div class="col-md-2" style="padding:0px;text-align:right">
                  <!-- <p align="right" style="font-family: kalpurush;color black;color:black;font-size:10px; border: 1px solid black;">ব্যাংক কপি</p> -->
                </div>
              </div>
              <div class="row" style="padding:10px">
                <div class="col-md-3" style="padding:0px">
                  <img alt="" class="img-fluid" style="height:55px" :src="personal.photo">
                </div>
                <div class="col-md-6" style="padding:0px">
                  <p align="center" style="font-family: kalpurush; color:black; margin:15px; borderx: 1px solid black;">ব্যাংক রসিদ</p>
                </div>
                <div class="col-md-3" style="padding:0px;">
                  <div class="qrcode ml-auto" style="float:right" :ref="'qrCodeUrl'+index" :id="'qrCodeUrl'+index"></div>
                </div>
              </div>
              <div class="row" style="padding:0px 10px">
                <div class="col-md-6" style="padding:0px">
                  <p style="font-family: kalpurush;color:black;font-size:11px">ক্রমিক নং- <span style="font-family:'Times New Roman', Times, serif; border-bottom: 1px dotted black; padding-left:10px; padding-right:10px; font-size:11px;">{{admission.memo_receipt}}</span></p>
                </div>
                <div class="col-md-2" style="padding:0px;text-align:right">
                  <p style="font-family: kalpurush;color:black;font-size:11px">তারিখ</p>
                </div>
                <div class="col-md-4" style="border-bottom: 1px dotted black;margin-top:10px;font-size:11px"></div>

                <div class="col-md-4x" style="width: 30%; padding:0px; margin:0px;">
                  <p style="font-family: kalpurush;color:black;font-size:11px;padding:10px 0px 5px 0px;">ছাত্র/ছাত্রীর নাম </p>
                </div>
                <div class="col-md-8x" style="width: 70%; border-bottom: 1px dotted black;margin-top:10px">
                  <p style="font-family:'Times New Roman', Times, serif;color:black; font-size:11px;">{{personal.name[0]}}</p>
                </div>
                <div class="col-md-12" style="width: 100%; border-bottom: 1px dotted black;margin-top:10px; padding-bottom:5px">
                  <p style="font-family:'Times New Roman', Times, serif;color:black; font-size:11px;">&nbsp;{{personal.name[1]}}</p>
                </div>
                
                <div class="col-md-auto" style="padding:0px">
                  <p style="font-family: kalpurush;color:black;font-size:11px; padding:10px 0px 5px 0px">রেজিস্ট্রেশন নং- <span style="font-family:'Times New Roman', Times, serif; border-bottom: 1px dotted black; padding-left:10px; padding-right:10px; font-size:11px;">{{admission.regino}}</span></p>
                </div>
                <div class="col-md-auto" style="padding:0px;">
                  <p style="font-family: kalpurush;color:black;font-size:11px; padding:10px 0px 5px 0px">ভর্তি পরীক্ষার রোলঃ <span style="font-family:'Times New Roman', Times, serif; border-bottom: 1px dotted black; padding-left:10px; padding-right:10px; font-size:11px;">{{admission.exam_roll}}</span></p>
                </div>

                <div class="col-md-1x" style="width:10%; padding:0px;">
                  <p style="font-family: kalpurush;color:black;font-size:11px;padding:10px 0px 5px 0px">শ্রেণী </p>
                </div>
                <div class="col-md-11x" style="width:90%; border-bottom: 1px dotted black;margin-top:10px">
                  <p align="center" style="font-family:'Times New Roman', Times, serif;color:black;font-size:11px;">{{admission.course}}</p>
                </div>
                <div class="col-md-2x" style="width:12%; padding:0px;">
                  <p style="font-family: kalpurush;color:black;font-size:11px;padding:10px 0px 5px 0px">বিভাগ</p>
                </div>
                <div class="col-md-10x" style="width:88%; border-bottom: 1px dotted black;margin-top:10px">
                  <p align="center" style="font-family:'Times New Roman', Times, serif;color:black;font-size:11px;height:20px;overflow-y:hidden;">{{fees.department_name}}</p>
                </div>
                <div class="col-md-2x" style="width:10%; padding:0px;">
                  <p style="font-family: kalpurush;color:black;font-size:11px;padding:10px 0px 5px 0px">বর্ষ </p>
                </div>
                <div class="col-md-10x" style="width:90%; border-bottom: 1px dotted black;margin-top:10px">
                  <p align="center" style="font-family:'Times New Roman', Times, serif;color:black;font-size:11px;">1<sup>st</sup> Year</p>
                </div>
                <div class="col-md-2x" style="width:12%; padding:0px;">
                  <p style="font-family: kalpurush;color:black;font-size:11px;padding:10px 0px 5px 0px">সেশন</p>
                </div>
                <div class="col-md-10x" style="width:88%; border-bottom: 1px dotted black;margin-top:10px">
                  <p align="center" style="font-family:'Times New Roman', Times, serif;color:black;font-size:11px;">{{admission.session}}</p>
                </div>
              </div>
              <div class="row" style="padding-botton:0px;">
                <div class="col-md-12" style="padding-top:10px;">
                  <table class="table table-bordered table-sm" style="padding:0; margin-bottom:0px;">
                    <thead>
                      <tr>
                        <th style="font-family: kalpurush; color:black; font-size:11px; text-align:center; width:18%;">ক্রঃ নং</th>
                        <th style="font-family: kalpurush;color:black;font-size:11px;text-align:center" width="42%">বিবরণ</th>
                        <th style="font-family: kalpurush; color:black; font-size:11px; text-align:right; width: 40%">টাকা</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">১</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">ভর্তি ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.admission_fee}}.00</td>
                      </tr>
                      
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">২</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">বেতন</td>
                        <td style="text-align:right; font-size:11px;">{{fees.tution_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">৩</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">গ্রন্থাগার ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.library_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">৪</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">ল্যাবরেটরী ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.lab_fee?fees.lab_fee:''}}{{fees.lab_fee?'.00':''}}</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">৫</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">গ্রন্থাগার ই-রিসোর্চ ও ইন্টারনেট সেবা ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.libcard_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">৬</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">রেজিস্ট্রেশন ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.registration_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">৭</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">মার্কস যাচাই ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.verification_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">৮</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">সেশন ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.session_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">৯</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">ভর্তি সহায়ক ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.aassistance_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">১০</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">রোভার স্কাউট ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.scout_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">১১</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">শিক্ষা উন্নয়ন খাত</td>
                        <td style="text-align:right; font-size:11px;">{{fees.edication_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">১২</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">উস ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.us_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">১৩</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">পরিবহন ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.transport_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">১৪</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">আই.ডি. কার্ড ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.idcard_fee}}.00</td>
                      </tr> 
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">১৫</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">বি.এন.সি.সি ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.bncc_fee}}.00</td>
                      </tr>
                      <tr>
                        <td style="font-family: kalpurush;color:black;font-size:12px;text-align:center;width:30px">১৬</td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;">চিকিৎসা ফি</td>
                        <td style="text-align:right; font-size:11px;">{{fees.medical_fee}}.00</td>
                      </tr>
                      <tr style="font-weight: bold;">
                        <td width="60" style="font-family: kalpurush;color:black;font-size:11px;text-align:center;width:30px"></td>
                        <td style="font-family: kalpurush;color:black;font-size:11px;text-align:right">মোট</td>
                        <td style="text-align:right; font-size:11px;">{{fees.total_fee_number}}.00</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" style="padding:0px 10px">
                <div class="col-md-1" style="padding:0px;">
                  <p style="font-family: kalpurush;color:black;font-size:11px;padding:15px 0px 5px 0px;letter-spacing:0px">কথায়</p>
                </div>
                <div class="col-md-11" style="border-bottom: 1px dotted black; margin-top:10px; font-size:11px;">{{fees.total_fee_word[0]}}</div>
                <div class="col-md-21" style="border-bottom: 1px dotted black; margin-top:0px; font-size:11px;">&nbsp;{{fees.total_fee_word[1]}} Taka Only</div>

                <div class="col-md-4" style="padding:0px;">
                  <p style="font-family: kalpurush;color:black;font-size:11px;padding:10px 0px 5px 0px;letter-spacing:0px">ছাত্র/ছাত্রীর স্বাক্ষর</p>
                </div>
                <div class="col-md-8" style="border-bottom: 1px dotted black; margin-top:0px;">&nbsp;</div>

                <div class="col-md-5" style="padding:0px;">
                  <p style="font-family: kalpurush;color:black;font-size:11px;padding:10px 0px 5px 0px;letter-spacing:0px">ব্যাংক কর্মকর্তার স্বাক্ষর</p>
                </div>
                <div class="col-md-7" style="border-bottom: 1px dotted black; margin-top:0px">&nbsp;</div>

                <div class="col-md-4" style="padding:0px;width:40%; border-bottom: 1px dotted black;">
                  <p style="font-family: kalpurush;color:black;font-size:11px;padding:10px 0px 5px 0px;letter-spacing:0px;">টাকা জমা দানের তারিখ</p>
                </div>
                <div class="col-md-1" style="width:10%">&nbsp;</div>
                <div class="col-md-5" style="border-top: 1px solid black;margin: 25px 0px 0px 0px; padding-top: 5px; text-align:center;width:50%">
                  <p style="font-family: kalpurush; color:black; font-size:11px; letter-spacing:0px;">অফিসার/ক্যাশিয়ার</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </sectionx>   
    </div>
    <div v-else>
        <loader class="loader"></loader> <br />
    </div>
  </div>
</template>

<script>
import Loader from '../Helper/Loader'
import Banner from '../Partial/Banner'
import { GET_BANK_SLIP } from '../../const/api'
import { GET } from '../../utils/Request'
import QRCode from 'qrcodejs2'
export default {
  name: 'BankSlip',
  components: { Loader, Banner },
  data() {
    return {
        loading: false,
        firstTimeLoad: true,
        qrText:'',

        personal : {},
        admission : {},
        fees : {}
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.getDocs();
  },
  mounted() { 
  },
  methods: {
    
    async getDocs() {
      var data = await GET(GET_BANK_SLIP);

      /*console.log(data.data);*/

      if(data.data.status=='success'){
        this.personal = data.data.personal;
        this.admission = data.data.admission;
        this.fees = data.data.fees;

        /*let today = new Date();
        this.admission.payment_date = today.toDateString();*/

        this.qrText = `${process.env.VUE_APP_FRONTEND_URL}check-sif/${ this.admission.hash_key}`;
        /*this.qrText = 'http://dev.front.cu.ac.bd/check-sif/' + this.admission.hash_key;*/


      }else {
        this.$iziToast.error({
            message: data.data.message
        });
        this.goForUrl('/');
      }
      this.timeoutForLoading();
    },
    
    goForUrl(url) {
      this.$router.replace(url)
    },

    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function() {
              this.loading = false;
              this.getQR();
              window.print();
            }.bind(this),
            3000
          )
        })
      }
      this.firstTimeLoad = false
    },

    getQR()
    {
      for(let i = 1; i<=4;++i){
        let canvasDiv = document.createElement("div"); //New dom element, if there is only one page, you can use the page element directly
        let id = 'qrCodeUrl'+i;
        let canvasId = 'canvas'+i;
        canvasDiv.id = canvasId;
        document.getElementById(id).append(canvasDiv);
        let qrcode = new QRCode(canvasId, { //qrcode generates QR code
          text: this.qrText,
          width: 50,
          height: 50,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
        // let canvas = document.getElementById(canvasId).querySelector(canvasId) //Get the canvas element
        // var dataURL = canvas.toDataURL(); 
        // canvas = null; 
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table>:not(:last-child)>:last-child>* {
    border-bottom-color: #8a8484;
}
.table thead th {
    border-bottom: 2px solid #8a8484;
}
.table-bordered td, .table-bordered th {
    border: 1px solid #8a8484;
}
.bg {
  /* The image used */
  background-image: url("../../theme-assets/images/logo/cu_bg_logo.png");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.loader {
  margin-top: 20%;
}
.pdf-app{
  width:100%;
  height:182.5vh;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}

th, td {
  padding: 0px 5px;
}

/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
   box-sizing: border-box;
}

@page {
  size: Legal Landscape;
}
</style>